var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRerun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74503 2.91748C8.20661 2.24148 7.476 1.73182 6.64258 1.45085C5.80916 1.16987 4.90907 1.12977 4.05244 1.33545C3.19581 1.54112 2.41978 1.98366 1.81929 2.60891C1.21881 3.23416 0.819902 4.01502 0.671387 4.85594M8.96788 0.671326V3.13286H6.42099M1.54879 8.27133C2.08706 8.94758 2.81766 9.45749 3.65115 9.73864C4.48464 10.0198 5.38486 10.06 6.24161 9.85425C7.09836 9.64855 7.87447 9.20589 8.47494 8.58045C9.07541 7.95502 9.47418 7.17395 9.62244 6.33286M1.32657 10.5175V8.05594H3.87347",
    stroke: "#004C4B",
    strokeWidth: 1.34266,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRerun);
export default __webpack_public_path__ + "static/media/rerun.2fe9b5811313b25d9a8035ef511040d7.svg";
export { ForwardRef as ReactComponent };